import { createStore, combineReducers, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import * as Ifr from "./ifr/reducer";
import * as AppStore from "./appStore/reducer";
import * as ZoneRegister from "./Zone/reducer";
import * as zoneSettingData from "./ZoneSetting/reducer";
import * as GridLayout from "./GridLayout/reducer";
import thunk from "redux-thunk";

let store = createStore(
  combineReducers({
    ...Ifr,
    ...AppStore,
    ...ZoneRegister,
    ...zoneSettingData,
    ...GridLayout
  }),
  {},
  composeWithDevTools(applyMiddleware(thunk))
);
export default store;
